import React from 'react';
import { Routes, Route } from "react-router-dom";

import Home from './Home/Home';
import Error from './Error/Error';
import Product from './Product/Product';
import Categories from './Categories/Categories';
import Accessories from './Accessories/Accessories';
import Categorie from './Categorie/Categorie';
import ProductDetail from './ProductDetail/ProductDetail';
import OurMission from './OurMission/OurMission';
import MyOrders from './MyOrders/MyOrders';
import OrdersDetails from './OrdersDetails/OrdersDetails';
import ManageAddresses from './ManageAddresses/ManageAddresses';
import Checkout from './Checkout/Checkout';
import Policy from './Policy/Policy';
import Search from './Search/Search';
import PaymentStatus from './PaymentStatus/PaymentStatus';
import Profile from './Profile/Profile';
import Wishlist from './Wishlist/Wishlist';
import FindYourModel from './FindYourModel/FindYourModel';
import Aboutus from './Aboutus/Aboutus';
import ComboProduct from './ComboProduct/ComboProduct';
import ComboProductDetail from './ComboProductDetail/ComboProductDetail';
import ScrollToTop from './ScrollToTop';

import '../assets/fonts/font.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import "../assets/style/style.css";
import "../assets/style/responsive.css";
import 'react-toastify/dist/ReactToastify.css';

const Main = () => {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/our-mission" element={<OurMission />} />

        <Route exact path="/categories" element={<Categories />} />
        <Route exact path="/categorie/:id" element={<Categorie />} />
        <Route exact path="/categorie/:modelid" element={<Categorie />} />
        <Route exact path="/product/categories/:id" element={<Product />} />
        <Route exact path="/product/categories/:id/:brandId/:modalId" element={<Product />} />
        <Route exact path="/product/categories/:id/:brandId/:modalId/:slugs?" element={<Product />} />
        <Route exact path="/product/plan/:slugs?" element={<Product />} />
        <Route exact path="/product" element={<Product />} />
        <Route exact path="/product/*" element={<ProductDetail />} />

        <Route exact path="/myorders" element={<MyOrders />} />
        <Route exact path="/myorders/*" element={<OrdersDetails />} />
        <Route exact path="/manage-addresses" element={<ManageAddresses />} />
        <Route exact path="/checkout" element={<Checkout />} />
        <Route exact path="/profile" element={<Profile />} />
        <Route exact path="/search/" element={<Search />} />
        <Route exact path="/search/:id" element={<Search />} />
        <Route exact path="/wishlist" element={<Wishlist />} />
        <Route exact path="/policys/:id" element={<Policy />} />
        <Route exact path="/payment-status" element={<PaymentStatus />} />
        <Route exact path="/find-your-model" element={<FindYourModel />} />
        <Route exact path="/find-your-model/:id" element={<FindYourModel />} />
        <Route exact path="/accessories/:brandId/:modalId" element={<Accessories />} />
        <Route exact path="/accessories/:brandId/:modalId/:slug" element={<Accessories />} />
        <Route exact path="/about-us" element={<Aboutus />} />
        {/* <Route exact path="/bundle-deals" element={<ComboProduct />} />
        <Route exact path="/bundle-deals/*" element={<ComboProductDetail />} /> */}

        <Route exact path="*" element={<Error />} />
      </Routes>
    </>
  );
}

export default Main